/* Nội dung Điều khoản dịch vụ, chép nguyên văn từ views/term_of_service.ejs của API (cả lỗi chính tả cũ). */
import { ReactNode } from "react";

export const TERMS_UPDATED = "Cập nhật lần cuối ngày 12/09/2023";

export const TERMS_SECTIONS: { id: string; title: string; body: ReactNode }[] =
  [
    {
      id: "trach-nhiem-khach-hang",
      title: "Trách nhiệm của khách hàng",
      body: (
        <>
          <p>
            Người sử dụng (bên mua) phải tự chịu trách nhiệm và đảm bảo với
            chúng tôi (bên cung cấp) trong việc sử dụng Máy chủ của mình trên hệ
            thống vào những mục đích hợp pháp. Đặc biệt trong những trường hợp
            sau:
          </p>
          <ol>
            <li>
              Không dùng server vào bất kì mục đích/hình thức nào vi phạm pháp
              luật Việt Nam, đặc biệt về vấn đề chính trị, tôn giáo, bản quyền…
              Đồng thời có trách nhiệm kiểm soát và ngăn cấm người khác làm điều
              đó trên máy chủ của mình.
            </li>
            <li>
              Bất kì loại dữ liệu nào mang tính bất hợp pháp, đe dọa, lừa dối,
              thù hằn, xuyên tạc, nói xấu, tục tĩu, khiêu dâm, xúc phạm…hay các
              hình thức bị ngăn cấm khác dưới bất kì cách thức nào.
            </li>
            <li>
              Bất kì loại dữ liệu nào mà cấu thành hoặc khuyến khích các hình
              thức phạm tội; hoặc các dữ liệu mang tính vi phạm luật sáng chế,
              nhãn hiệu, quyền thiết kế, bản quyền hay bất kì quyền sỡ hữu trí
              tuệ hoặc các quyền hạn của bất kì cá nhân nào.
            </li>
            <li>
              Không sử dụng dịch vụ của PCRENDER cung cấp cho mục đích: tổ chức
              đánh bạc, cá độ, lô đề, hack, tấn công phá hoại (DDoS), lừa đảo,
              Spam Mail (Spam Email trong trường hợp này được hiểu là thư rác
              điện tử theo quy định tại Nghị định 90/2008/NĐ-CP hoặc bất kỳ văn
              bản nào thay thế Nghị định 90/2008/NĐ-CP sau này). Nếu vi phạm
              điều khoản này, khách hàng sẽ hoàn toàn tự mình chịu trách nhiệm
              trước pháp luật mà không liên quan đến chúng tôi.
            </li>
            <li>
              Khách hàng tự bảo mật an ninh, an toàn các thông tin liên quan tới
              tài chính trên máy chủ (Ví bitcoin, Paypal, các tài khoản có giá
              trị…). Pcrender chỉ cung cấp máy chủ và đảm bảo máy chủ hoạt động
              ổn định. Pcrender không khuyến khích và không chịu bất cứ trách
              nhiệm nào liên quan tới việc rò rỉ, mất mát tài chính liên quan
              tới việc máy chủ bị xâm nhập trái phép từ bên thứ 3.
            </li>
            <li>
              Người sử dụng giữ một cách an toàn các thông tin nhận biết, mật
              khẩu hay những thông tin mật khác liên quan đến tài khoản của mình
              và lập tức thông báo cho chúng tôi khi phát hiện các hình thức
              truy cập trái phép bằng tài khoản của mình hoặc các sơ hở về bảo
              mật, bao gồm việc mất mát, đánh cắp hoặc để lộ các thông tin về
              mật khẩu và các thông tin bảo mật khác.
            </li>
            <li>
              Người sử dụng không dùng các chương trình có khả năng làm tắc
              nghẽn hoặc đình trệ hệ thống, như gây cạn kiệt tài nguyên hệ
              thống, làm quá tải bộ vi xử lý và bộ nhớ (HACK, DoS, DDoS,
              Malwares, Virus, VPN, Mining Coin (hay còn gọi là đào Bitcoin hoặc
              các loại tiền mã hóa),..)
            </li>
            <li>
              Người sử dụng được dùng tài nguyên host theo đúng thông số tương
              ứng gói dịch vụ đã đăng ký. Tuy nhiên, nhằm đảm bảo chất lượng cho
              máy chủ phục vụ, hệ thống sẽ tự động phát hiện các Máy chủ, Host
              có dấu hiệu lạm dụng tài nguyên hệ thống quá mức (thường xuyên sử
              dụng CPU ở mức cao, chiếm dụng băng thông lớn…) và đưa ra các
              phương án giải quyết phù hợp như: Yêu cầu Khách hàng giảm tải, hệ
              thống chủ động giới hạn tài nguyên, tạm dừng dịch vụ, hủy dịch vụ…
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "ben-cung-cap",
      title: "Quyền và trách nhiệm của bên cung cấp",
      body: (
        <>
          <ol>
            <li>
              Bảo mật thông tin của khách hàng và những dữ liệu khách hàng cung
              cấp cho Pcrender . Không được phép cung cấp thông tin cho bất kỳ
              bên thứ ba nào ngoại trừ khi có yêu cầu của các cơ quan chức năng
              có thẩm quyền hoặc được sự chấp thuận của khách hàng.
            </li>
            <li>
              Trong khi dùng các biện pháp có thể và nỗ lực nhằm bảo đảm sự toàn
              vẹn và an toàn cho server, chúng tôi không chịu trách nhiệm bồi
              thường dữ liệu của người sử dụng lưu trữ tại máy chủ trong trường
              hợp hệ thống server bị phá hoại từ những người dùng bất hợp pháp,
              các hacker hoặc do các sự cố bất khả kháng: thiên tai, hoả hoạn,
              hệ thống máy chủ hỏng vật lý phần cứng.
            </li>
            <li>
              Chúng tôi sẽ tạm ngưng dịch vụ mà không cần thông báo trước vì lý
              do vi phạm từ phía người sử dụng ở các mục đã nêu trên. Trường hợp
              muốn mở lại, khách hàng phải cam kết không tái diễn vi phạm. Trong
              trường hợp xấu nhất, chúng tôi sẽ buộc phải cắt dịch vụ vĩnh viễn
              mà không hoàn trả lại phí.
            </li>
            <li>
              Trước khi dịch vụ gần hết hạn, hệ thống sẽ cảnh báo tới máy tính
              quý khách đang sử dụng. Nếu khách hàng không gia hạn, hệ thống sẽ
              tự động hủy dịch khi hết giờ và <b>không thể khôi phục lại</b>.
              Chúng tôi không chịu trách nhiệm trong trường hợp Khách hàng không
              theo dõi thông báo.
            </li>
            <li>
              Hệ thống dùng đóng băng ổ cứng nên dẫn đến không lưu được dữ liệu
              khi tắt máy hoặc khởi động lại ,hoặc bị mất điện đột xuất. Vì vậy,
              chúng tôi khuyến cáo người sử dụng nên sao lưu dữ liệu thường
              xuyên về máy tính hoặc trên các thiết bị lưu trữ của mình để tránh
              những sự cố đáng tiếc xảy ra.
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "thanh-toan",
      title: "Quy định về thanh toán",
      body: (
        <>
          <ol>
            <li>
              Chúng tôi không hoàn tiền khi bạn đã khởi tạo dịch vụ thuê máy
              tính trên trang
            </li>
            <li>
              Sử dụng duy nhất VNĐ cho thanh toán các dịch vụ. Các dịch vụ cung
              cấp đều là dịch vụ trả trước. Bên bán có quyền từ chối các khoản
              thanh toán liên quan tới gian lận (sử dụng các tài khoản hack,
              trộm cắp hoặc thông qua các bug, lỗi của website để thực hiện nạp
              tiền, sử dụng dịch vụ…) đồng thời sẽ thông báo tới các cơ quan
              chức năng khi cần thiết.
            </li>
            <li>
              Các khoản dư của khách hàng trong tài khoản tại website{" "}
              <a href="https://pcrender.com">Pcrender.com</a> không có giá trị
              sử dụng để mua bán, hoàn tiền, mục đích số dư chỉ để sử dụng thuê
              máy chủ, số dư nạp tối thiểu 50.000 vnđ nên khách hàng lưu ý sử
              dụng bao nhiêu nạp bấy nhiêu, không có hoàn tiền khi đã nạp vào
              nhằm tránh các trường hợp rửa tiền.
            </li>
            <li>
              Nếu cần xuất hóa đơn VAT, quý khách vui lòng liên hệ với nhân viên
              chăm sóc khách hàng.
            </li>
            <li>
              Quý khách hàng vui lòng ghi rõ nội dung thanh toán khi chuyển tiền
              vào tài khoản của Pcrender.
            </li>
            <li>
              Quý khách hàng hoàn toàn chịu trách nhiệm với những trường hợp
              gián đoạn dịch vụ do giao dịch chuyển tiền có nội dung không đầy
              đủ hoặc nội dung không chính xác hoặc không có nội dung và không
              thông báo với Pcrender.
            </li>
            <li>
              Nếu điều kiện thanh toán không cho phép điền nội dung hoặc trong
              vòng 48 giờ kể từ thời gian thanh toán nếu Quý khách hàng không
              nhận được email xác nhận, Quý khách hàng vui lòng liên hệ CSKH qua
              hotline hoặc trực tiếp trên website để được hỗ trợ.
            </li>
            <li>
              Quý khách hàng chịu các khoản phí giao dịch với ngân hàng hoặc các
              khoản phí phát sinh do bên thứ ba (nếu có).
            </li>
            <li>
              Trường hợp Quý khách hàng thực hiện thanh toán tại Việt Nam thì sẽ
              phải thanh toán thêm 10% VAT và ngược lại, Quý khách hàng sẽ được
              miễn thuế nếu thanh toán ngoài Việt Nam.
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "tam-ngung",
      title: "Tạm ngừng và chấm dứt sử dụng dịch vụ",
      body: (
        <>
          <ol>
            <li>
              Dịch vụ do Pcrender cung cấp sẽ tự động chấm dứt/tạm ngừng theo
              thỏa thuận của hai bên hoặc đến thời điểm hết hiệu lực hợp đồng
              hợp tác dịch vụ.
            </li>
            <li>
              Pcrender có quyền tạm dừng thực hiện hợp đồng hoặc đơn phương chấm
              dứt hợp đồng dịch vụ trong các trường hợp sau đây
              <ul>
                <li>
                  Khách hàng có hành vi vi phạm quy định của Điều khoản sử dụng
                  dịch vụ trong quá trình sử dụng sản phẩm, dịch vụ của chúng
                  tôi.
                </li>
                <li>
                  Khách hàng không hợp tác và không đáp ứng phối hợp bổ sung tài
                  liệu cần thiết.
                </li>
                <li>
                  Khách hàng không thực hiện việc gia hạn kể từ thời điểm hết
                  hạn sử dụng dịch vụ.
                </li>
              </ul>
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "bao-mat",
      title: "Chính sách bảo mật thông tin khách hàng",
      body: (
        <>
          <ol>
            <li>
              <h3>Thông tin khách hàng</h3>
              <ul>
                <li>
                  Pcrender tôn trọng sự riêng tư và quản lý nghiêm túc thông tin
                  của khách hàng.
                </li>
                <li>
                  Thông tin khách hàng gồm có tên, địa chỉ email, số điện thoại,
                  địa chỉ liên hệ và các thông tin cá nhân khác do khách hàng
                  chủ động cung cấp hoặc được Pcrender thu thập bằng các phương
                  thức hợp lệ khác.
                </li>
                <li>
                  Thông tin khách hàng không bao gồm dữ liệu về website và các
                  dịch vụ khác của khách hàng đang sử dụng hoặc lưu trữ trên máy
                  chủ cung cấp dịch vụ của Pcrender.
                </li>
                <li>
                  Thông tin thu thập từ phía khách hàng được Pcrender sử dụng
                  nội bộ cho các nhu cầu cung cấp dịch vụ, liên hệ, thông báo và
                  tư vấn cho khách hàng trên hệ thống. Pcrender cam kết không
                  chia sẻ thông tin khách hàng dưới bất kỳ hình thức nào cho bên
                  thứ ba
                </li>
              </ul>
            </li>
            <li>
              <h3>Dữ liệu khách hàng</h3>
              <ul>
                <li>
                  Dữ liệu của khách hàng tự quản lý và lưu trữ trên các máy chủ
                  cung cấp dịch vụ của Pcrender.
                </li>
              </ul>
            </li>
            <li>
              <h3>Thu thập thông tin khách hàng</h3>
              <ul>
                <li>
                  Khách hàng có thể liên hệ với Pcrender hoặc truy cập các
                  website trong hệ thống quản lý của Pcrender để phục vụ nhu cầu
                  tìm hiểu thông tin về dịch vụ và có thể lựa chọn không cung
                  cấp các thông tin cá nhân.
                </li>
                <li>
                  Khi đăng ký và sử dụng dịch vụ của Pcrender, khách hàng phải
                  cung cấp các thông tin liên hệ đầy đủ và chính xác theo yêu
                  cầu của Quy định sử dụng dịch vụ.
                </li>
                <li>
                  Khi khách hàng truy cập vào các website trong hệ thống quản lý
                  của Pcrender, chúng tôi có thể sử dụng một số cơ chế đánh dấu
                  qua trình duyệt (cookies) để hỗ trợ việc sử dụng các tiện ích
                  của website. Khách hàng có thể cấu hình trình duyệt để tùy
                  chỉnh việc bật tắt các cơ chế này.
                </li>
                <li>
                  Khi khách hàng truy cập vào các website trong hệ thống quản lý
                  của Pcrender, chúng tôi có thể lưu trữ thông tin về trình
                  duyệt, hệ điều hành và thông tin địa chỉ mạng (IP) của khách
                  hàng cho mục đích thống kê hoặc kiểm soát truy cập.
                </li>
              </ul>
            </li>
            <li>
              <h3>Thu thập dữ liệu của khách hàng</h3>
              <ul>
                <li>
                  Pcrender không thu thập dữ liệu của khách hàng dưới bất kỳ
                  hình thức nào. Dữ liệu của khách hàng phải do khách hàng chủ
                  động cung cấp cho Pcrender hoặc do khách hàng trực tiếp lưu
                  trữ trên các máy chủ cung cấp dịch vụ của Pcrender.
                </li>
              </ul>
            </li>
            <li>
              <h3>Thời gian lưu trữ thông tin</h3>
              <ul>
                <li>
                  Toàn bộ thông tin cá nhân của khách hàng đều được lưu trữ bảo
                  mật trên hệ thống nội bộ của Pcrender trong suốt quá trình sử
                  dụng dịch vụ hoặc cho đến khi nhận được yêu cầu hủy bỏ các
                  thông tin đã cung cấp từ phía khách hàng.
                </li>
              </ul>
            </li>
            <li>
              <h3>Lưu trữ dữ liệu của khách hàng</h3>
              <ul>
                <li>
                  Pcrender không sao lưu hoặc lưu trữ dữ liệu của khách hàng trừ
                  các hình thức đã được xác định cần thiết để cung cấp dịch vụ
                  và được khách hàng xác nhận.
                </li>
                <li>
                  Dữ liệu của khách hàng được lưu trữ cho tới khi khách hàng
                  ngừng sử dụng dịch vụ của Pcrender hoặc khách hàng chủ động
                  yêu cầu xóa / hủy dữ liệu.
                </li>
                <li>
                  <h3>Sử dụng thông tin khách hàng</h3>
                  <p>
                    Pcrender sử dụng các thông tin do khách hàng chủ động cung
                    cấp hoặc thu thập được qua các hình thức khác dành cho mục
                    đích:
                  </p>
                  <ul>
                    <li>
                      Thống kê số lượng người truy cập vào website và mức độ
                      quan tâm tới các loại hình dịch vụ của chúng tôi.
                    </li>
                    <li>
                      Quản lý thông tin xác thực quyền sở hữu tài khoản khách
                      hàng (nếu khách hàng có đăng ký tài khoản với Pcrender) và
                      thực hiện các thao tác chăm sóc khách hàng, gồm có:
                      <ul>
                        <li>
                          Xử lý đơn đặt hàng và cung cấp dịch vụ đăng ký lưu trữ
                          nội dung website và các dịch vụ khác trong giới hạn
                          kinh doanh của Pcrender.
                        </li>
                        <li>
                          Tiếp nhận và phản hồi các thắc mắc, đóng góp ý kiến,
                          yêu cầu hỗ trợ, đề xuất hoặc khiếu nại liên quan tới
                          việc cung cấp các dịch vụ.
                        </li>
                        <li>
                          Cung cấp thông tin về các chương trình khuyến mãi,
                          bảng giá, chính sách bán hàng và phục vụ khách hàng.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p>
                    Pcrender cam kết không thực hiện việc quảng cáo các dịch vụ
                    không do Pcrender trực tiếp cung cấp hoặc gửi thư rác cho
                    các mục đích khác.
                  </p>
                  <p>
                    Pcrender cam kết không cung cấp thông tin liên hệ của khách
                    hàng cho các bên thứ ba, trừ các trường hợp được thông báo
                    với khách hàng như sau:
                  </p>
                  <ul>
                    <li>
                      Việc cung cấp là cần thiết để đảm bảo sử dụng dịch vụ (ví
                      dụ, đăng ký thông tin sở hữu tên miền với VNNIC).
                    </li>
                    <li>
                      Việc cung cấp được thực hiện theo yêu cầu bằng văn bản của
                      các đơn vị hành pháp tại Việt Nam.
                    </li>
                    <li>
                      Phương thức và công cụ để người dùng tiếp cận và chỉnh sửa
                      dữ liệu cá nhân của mình
                    </li>
                    <li>
                      Bảo vệ an toàn thông tin khách hàng và dữ liệu của khách
                      hàng.
                    </li>
                  </ul>
                  <p>
                    Pcrender cam kết sẽ nỗ lực triển khai các biện pháp bảo vệ
                    an toàn thông tin và dữ liệu của khách hàng trong khả năng
                    cho phép của mình, gồm có:
                  </p>
                  <ul>
                    <li>
                      Sử dụng giao thức truyền tin qua mạng Internet được mã hóa
                      với chứng chỉ số (SSL).
                    </li>
                    <li>
                      Xác thực quyền truy cập hoặc chỉnh sửa thông tin khách
                      hàng bằng các biện pháp khác trong trường hợp không truy
                      cập trực tiếp qua mạng Internet.
                    </li>
                  </ul>
                  <p>
                    Pcrender không chịu trách nhiệm nếu xảy ra các sự cố liên
                    quan tới an toàn thông tin khách hàng hoặc dữ liệu của khách
                    hàng phát sinh từ các nguyên nhân không nằm trong quyền kiểm
                    soát của Pcrender, gồm có nhưng không giới hạn bởi việc
                    khách hàng để lộ mật khẩu hoặc bị tấn công bảo mật thông qua
                    các phương thức khác không liên quan tới dịch vụ của
                    Pcrender.
                  </p>
                  <ul>
                    <li>Hệ thống website của Pcrender</li>
                  </ul>
                  <p>
                    Hệ thống website của Pcrender là trang web sử dụng tên miền
                    chính Pcrender.com
                  </p>
                  <p>
                    Các website của Pcrender có thể bao gồm các đường dẫn liên
                    kết tới các trang web khác nhằm mục đích giới thiệu hoặc bổ
                    sung thông tin. Chúng tôi không chịu trách nhiệm về nội dung
                    và chính sách bảo mật thông tin của các trang web này.
                  </p>
                  <h3>
                    Dịch vụ không bị xem là ngưng trệ trong các trường hợp sau:
                  </h3>
                  <ul>
                    <li>
                      Không truy cập được dịch vụ do đường truyền từ phía khách
                      hàng, lỗi từ phía DNS.
                    </li>
                    <li>
                      Không truy cập được dịch vụ do lỗi từ phía người dùng, cấu
                      hình sai.
                    </li>
                    <li>
                      Không truy cập được dịch vụ do lỗi từ phía dịch vụ mạng
                      của người sử dụng, lỗi từ hệ điều hành, virus spyware
                      v.v.. gây ra.
                    </li>
                    <li>
                      Không truy cập được dịch vụ do bị khóa vì vi phạm quy dịnh
                      sử dụng hoặc sử dụng các mã nguồn gây ảnh hưởng cục bộ đến
                      hệ thống.
                    </li>
                    <li>Không truy cập được dịch vụ do lỗi file hệ thống.</li>
                    <li>
                      Không truy cập được dịch vụ do phần cứng bị hư hỏng (thuê
                      chỗ đặt hoặc trường hợp thuê máy chủ vật lý).
                    </li>
                    <li>
                      Không truy cập được dịch vụ do hệ thống iptables,
                      firewall, lỗi dịch vụ trên máy chủ phát sinh trong quá
                      trình sử dụng.
                    </li>
                  </ul>
                  <h3>Yêu cầu bồi thường và thủ tục giải quyết:</h3>
                  <p>
                    Để yêu cầu bồi thường trong các trường hợp Pcrender không
                    đạt được cam kết, khách hàng vui lòng email đến địa chỉ :
                    support@pcrender.com
                  </p>
                  <p>
                    Quý khách chỉ được yêu cầu bồi thường trong vòng 7 ngày kể
                    từ thời điểm gián đoạn dịch vụ. Quá thời hạn trên được xem
                    như hết hiệu lực cam kết. Chúng tôi có quyền từ chối khiếu
                    nại.
                  </p>
                  <ol>
                    <li>
                      Tiêu đề mail ghi rõ “Yêu cầu bồi thường theo cam kết SLA”
                    </li>
                    <li>
                      Ngày và giờ cụ thể các thời điểm trạng thái không sẵn
                      sàng.
                    </li>
                    <li>Tài khoản và IP của các dịch vụ bị ảnh hưởng.</li>
                    <li>
                      Logs ghi lỗi hoặc hình ảnh chụp lại màn hình thời điểm xảy
                      ra lỗi (Lưu ý: các thông tin bảo mật nhạy cảm cần được xóa
                      mờ hoặc thay bằng các dấu hoa thị).
                    </li>
                  </ol>
                  <p>
                    Các yêu cầu bồi thường không cung cấp được các thông tin
                    trên sẽ không được chấp nhận hợp lệ.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "bat-kha-khang",
      title: "Bất khả kháng",
      body: (
        <>
          <ol>
            <li>
              Nếu bất kỳ sự kiện nào như thiên tai, dịch họa, lũ lụt, hoả hoạn,
              động đất, đình công, can thiệp của Nhà nước hay bất cứ sự kiện nào
              khác xảy ra ngoài tầm kiểm soát của bất kỳ bên nào và không thể
              lường trước được, thì Bên bị ảnh hưởng bởi sự kiện bất khả kháng
              sẽ được tạm hoãn thực hiện nghĩa vụ trong hợp đồng này, với điều
              kiện là Bên bị ảnh hưởng đó đã áp dụng mọi biện pháp cần thiết để
              ngăn ngừa, hạn chế hoặc khắc phục hậu quả của sự kiện đó.
            </li>
            <li>
              Bên bị ảnh hưởng bởi sự kiện bất khả kháng có nghĩa vụ thông báo
              cho bên còn lại ngay khi có thể. Trường hợp sự kiện bất khả kháng
              xảy ra, các bên được miễn trách nhiệm bồi thường thiệt hại.
            </li>
            <li>
              Nếu sự kiện bất khả kháng không chấm dứt trong vòng 30 (ba mươi)
              ngày làm việc hoặc một khoảng thời gian lâu hơn và vẫn tiếp tục
              ảnh hưởng đến việc thực hiện Hợp đồng hợp tác dịch vụ thì bên nào
              cũng có quyền đơn phương chấm dứt Hợp đồng và thông báo cho bên
              còn lại bằng văn bản trong vòng 10 (mười) ngày làm việc kể từ ngày
              dự định chấm dứt.
            </li>
          </ol>
        </>
      ),
    },
    {
      id: "thay-doi-chinh-sach",
      title: "Thay đổi chính sách",
      body: (
        <>
          <p>
            Điều khoản sử dụng dịch sẽ được thay đổi và cập nhật cho phù hợp với
            từng thời điểm và các loại hình dịch vụ. Khách hàng có trách nhiệm
            thường xuyên theo dõi email hoặc văn bản này để đảm bảo luôn thực
            hiện đúng theo các điều khoản quy định.
          </p>
          <p>
            Khi cập nhật nội dung chính sách này, Pcrender sẽ chỉnh sửa lại thời
            gian trong phần ghi chú “cập nhật lần cuối” trên website.
          </p>
        </>
      ),
    },
  ];
